import pickBy from 'lodash/pickBy';
import dayjs from 'dayjs';
/**
 * Remove dates from `dayMap` not in range [`dateFrom`, `dateTo`]
 */
export const prune = ({ dayMap, dateFrom, dateTo, }) => {
    if (!dateFrom && !dateTo) {
        return dayMap;
    }
    const dateFromDate = dayjs.utc(dateFrom);
    const dateToDate = dayjs.utc(dateTo);
    return pickBy(dayMap, (_, day) => (!dateFrom || dayjs.utc(day).isSameOrAfter(dateFromDate)) &&
        (!dateTo || dayjs.utc(day).isSameOrBefore(dateToDate)));
};
//# sourceMappingURL=DayMap.js.map